import dayjs from 'dayjs';
import type { Session } from '@/entities/auth/model/sessionSchema';

/** Сессия годится для клиента: не отозвана и не вышло время expires_at. */
export function isSessionValidForClient(session: Session): boolean {
  if (session.status === 'revoked') return false;
  const expiresAt = dayjs(session.expires_at);
  if (!expiresAt.isValid()) return false;
  return expiresAt.isAfter(dayjs());
}
